import { render, staticRenderFns } from "./CustomTargetingDetail.vue?vue&type=template&id=3f009b78"
import script from "./CustomTargetingDetail.vue?vue&type=script&lang=js"
export * from "./CustomTargetingDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports